import { ADD_CART } from '../actions/types'
import { GET_CART_REQUEST_SUCESSS } from '../actions/types'

const initialState = {
  cart: {},
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ADD_CART:
      return {
        cart: action.cart,
      }
    case GET_CART_REQUEST_SUCESSS:
      return {
        cart: action.cart,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/ducks/reducers/cart.js